'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectAll = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Option = require('../Option');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectAll = exports.SelectAll = function SelectAll(p) {
  return _react2.default.createElement(
    'li',
    { className: 'OptionList__item DropDown__selectAll' },
    _react2.default.createElement(_Option.Option, {
      Option: p.Option,
      option: {
        label: p.selectAllLabel,
        value: ''
      },
      checked: p.checked,
      focused: p.focused,
      onClick: p.onClick
    })
  );
};